var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHyperspaceS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.10203 2H6.13307L4.55233 5.4134C4.414 5.7121 4.34483 5.86143 4.36579 5.97553C4.38422 6.07587 4.45001 6.15747 4.55372 6.2086C4.67162 6.26673 4.8612 6.26673 5.24036 6.26673H6.59439C6.68917 6.26673 6.7366 6.26673 6.76607 6.28127C6.79197 6.29403 6.80843 6.31443 6.81303 6.33953C6.81827 6.36807 6.80098 6.4054 6.7664 6.48007L6.12423 7.86677H4.63479C3.4973 7.86677 2.92855 7.86677 2.57485 7.69237C2.26372 7.53897 2.06636 7.2942 2.01106 6.99313C1.9482 6.65087 2.15569 6.2028 2.57068 5.30672L4.10203 2ZM7.74926 10H5.71821L7.29896 6.5866C7.43729 6.2879 7.50648 6.13857 7.48551 6.02447C7.46707 5.92413 7.4013 5.84253 7.29757 5.7914C7.17967 5.73327 6.99011 5.73327 6.61095 5.73327H5.25691C5.16211 5.73327 5.11472 5.73327 5.08524 5.71873C5.05931 5.70597 5.04287 5.68557 5.03826 5.66047C5.03302 5.63193 5.05031 5.5946 5.08489 5.51993L5.72708 4.13324H7.2165C8.35401 4.13324 8.92274 4.13324 9.27646 4.30764C9.58757 4.46104 9.78494 4.70581 9.84025 5.00687C9.90311 5.34913 9.69559 5.7972 9.28063 6.69327L7.74926 10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperspaceS);
export default __webpack_public_path__ + "static/media/hyperspace-s.992260edccc42ef2c7d9081962b9ebb2.svg";
export { ForwardRef as ReactComponent };